import { useState } from 'react';

import { EmbeddedResourceRefModel } from '../../Models/EmbeddedResourceRefModel';
import { EmbeddedResourceInputDialog } from './EmbeddedResourceInputDialog';
import GenericPropertyInput from './GenericPropertyInput';
import GenericPropertyInputRefContent from './GenericPropertyInputRefContent';

type EmbeddedResourceInputProps = {
	embeddedResourceRef: EmbeddedResourceRefModel | undefined;
	onEmbeddedResourceRefChange: (embeddedResourceRef: EmbeddedResourceRefModel | undefined) => void;
	isEditable?: boolean;
};

export default function EmbeddedResourceInput({ embeddedResourceRef, onEmbeddedResourceRefChange, isEditable = true }: EmbeddedResourceInputProps) {
	const [open, setOpen] = useState(false);

	// In non-edit mode, just show the reference name
	if (!isEditable) {
		return <GenericPropertyInputRefContent value={embeddedResourceRef} />;
	}

	return (
		<GenericPropertyInput value={embeddedResourceRef} onValueChange={onEmbeddedResourceRefChange} onOpen={() => setOpen(true)}>
			<GenericPropertyInputRefContent value={embeddedResourceRef} />
			{open && (
				<EmbeddedResourceInputDialog
					open={open}
					setOpen={setOpen}
					embeddedResourceRef={embeddedResourceRef}
					onEmbeddedResourceRefChange={onEmbeddedResourceRefChange}
				/>
			)}
		</GenericPropertyInput>
	);
}
